import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"
import { htmlEscape, dataTruncate } from "lib/helpers"

// notifier--queue on `app/views/notifier/queue/index.haml` (#queue tab).
export default class extends Controller {
  static targets = ["table", "historyDialog", "checkAll"]

  static values = {
    removeEventsPath: String,
    notifierRootPath: String,
    usersServiceRoot: String,
    queuePath: String,
    reader: { type: Boolean, default: false },
  }

  connect() {
    if (!this.hasTableTarget) return

    this.#initMessageStatusHover()
    this.#initDataTable()
    this.#bindCheckboxChanges()
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }
    $(this.element).off(".notifierQueue")
    $(document).off(".notifierQueue")
    if (this.hasCheckAllTarget) $(this.checkAllTarget).off(".notifierQueue")
  }

  openHistory(event) {
    event.preventDefault()

    const link = event.currentTarget
    const id = link.dataset.eventId
    const path = `${this.notifierRootPathValue}/history/${id}`

    const loadingImage = `&nbsp;<img src="${window.ajax_table_loader_url}">`
    if (link.innerHTML === loadingImage) return

    link.innerHTML = loadingImage

    $(this.historyDialogTarget).load(path, () => {
      $(this.historyDialogTarget).find(".modal-title").append(` ${id} log`)
      $("#event_history_modal").modal("show")
    })
  }

  removeSelected(event) {
    event.preventDefault()

    const groupName = this.checkAllTarget.value
    const checkboxes = $(`input[name^='${groupName}']:checked`)
    const available = $(`input[name^='${groupName}']`)
    const allSelected = checkboxes.length === available.length

    if (!available.length) return
    if (!checkboxes.length) {
      alert("Please select at least one item")
      return
    }
    if (!confirm("Are you sure? All selected items will be removed")) return

    $(".dataTables_processing").css("display", "block")

    const ids = $.makeArray(checkboxes.map(function () { return $(this).val() }))

    $.get(this.removeEventsPathValue, { item_ids: ids }, () => {
      if (!this.dataTable) return

      const settings = this.dataTable.settings()[0]
      if (
        allSelected &&
        settings._iRecordsDisplay - settings._iDisplayStart <= settings._iDisplayLength
      ) {
        this.dataTable.page("previous").draw(false)
      } else {
        this.dataTable.draw(false)
      }
    })
    this.checkAllTarget.checked = false
  }

  #initMessageStatusHover() {
    $(this.element)
      .on("mouseenter.notifierQueue", ".message-status", function () {
        $(this).addClass("message-status-hover").css("color", "#51A0DE")
      })
      .on("mouseleave.notifierQueue", ".message-status", function () {
        $(this).removeClass("message-status-hover").css("color", "#206DAA")
      })
      .on("click.notifierQueue", ".message-status", function () {
        $(this).removeClass("message-status-hover").css("color", "#206DAA")
      })
  }

  #initDataTable() {
    const usersRoot = this.usersServiceRootValue
    const controller = this

    this.dataTable = createTurboDataTable(this.tableTarget, {
      order: [[9, "desc"]],
      dom: 'lrftip<"toolbar">',
      pagingType: "full_numbers",
      processing: true,
      serverSide: true,
      stateSave: true,
      scrollX: true,
      ajax: {
        url: this.queuePathValue || "queue",
        type: "post",
      },
      language: {
        searchPlaceholder: "by User login \\ ID:",
      },
      initComplete: () => {
        $("#loading").hide()
        $(".messages-queue").show()
        if (!controller.readerValue) controller.#installToolbar()
      },
      footerCallback() {
        $("#check-all").attr("checked", false)
      },
      columnDefs: [
        {
          targets: 0,
          createdCell(cell, cellData) {
            $(cell).html(
              `<input type="checkbox" class="table-checkbox-queue" id="check--queue${cellData}" name="item_ids[]" value="${cellData}"/> <label for="check--queue${cellData}"><label/>`,
            )
          },
        },
        {
          targets: 2,
          createdCell(cell, cellData) {
            if (!cellData) return

            const parts = cellData.split(" <")
            if (parts.length === 10) {
              cellData = parts[4].replace('text id="1">', "").replace("</text>", "")
            } else if (parts.length === 7) {
              cellData = parts[4].replace('text id="2">', "").replace("</text>", "")
            }
            const escaped = htmlEscape(cellData)
            const cropped = escaped.length > 25 ? `${escaped.substring(0, 25)}...` : escaped
            $(cell).html(cropped)
          },
        },
        {
          targets: 3,
          createdCell(cell, cellData, rowData) {
            const status = rowData[3]
            const eventId = rowData[1]
            $(cell).html(
              `<a href="#" class="message-status ${status}" id="event${eventId}" data-event-id="${eventId}" data-action="click->notifier--queue#openHistory"><span>${status}</span></a>`,
            )
          },
        },
        {
          targets: 4,
          createdCell(cell, cellData, rowData) {
            $(cell).html(
              `<a href="${usersRoot}/edit/${rowData[10]}"><span>${dataTruncate(htmlEscape(rowData[4]), 20)}</span></a>`,
            )
          },
        },
        {
          targets: 5,
          createdCell(cell, cellData) {
            $(cell).html(cellData ? moment(cellData).format() : "")
          },
        },
        {
          targets: 6,
          createdCell(cell, cellData) {
            $(cell).html(cellData ? moment(cellData).format() : "")
          },
        },
        {
          targets: 8,
          createdCell(cell, cellData) {
            controller.#renderChannelCell(cell, cellData)
          },
        },
        {
          targets: 9,
          createdCell(cell, cellData) {
            $(cell).html(cellData ? moment(cellData).format() : "")
          },
        },
        {
          targets: 10,
          createdCell(cell, cellData, rowData) {
            $(cell).html(rowData[11])
          },
        },
        {
          targets: [0, 2, 4, 10],
          sortable: false,
        },
      ],
    })
  }

  #installToolbar() {
    $("div.toolbar")
      .not(".rich")
      .html(
        '<br><br><a href="#" class="remove" data-action="click->notifier--queue#removeSelected">Remove selected</a>',
      )
  }

  #renderChannelCell(cell, cellData) {
    let title
    switch (cellData) {
      case "apns":
        title = "APNS"
        return $(cell).html(
          `<img src="${window.apple_logo_url}" alt="${title}" title="${title}"/>&nbsp;${title}`,
        )
      case "apns_voip":
        title = "APNS VOIP"
        return $(cell).html(
          `<img src="${window.apple_logo_url}" alt="${title}" title="${title}"/>&nbsp;${title}`,
        )
      case "gcm":
        title = "FCM"
        return $(cell).html(
          `<img src="${window.android_logo_url}" alt="${title}" title="${title}"/>&nbsp;${title}`,
        )
      case "email":
        title = "E-Mail"
        return $(cell).html(
          `<img src="${window.tick_logo_url}" alt="${title}" title="${title}"/>&nbsp;${title}`,
        )
    }
  }

  #bindCheckboxChanges() {
    $(document).on("change.notifierQueue", ".table-checkbox-queue", function () {
      const isChecked = $(this).prop("checked")
      $(this).closest("tr").toggleClass("selected-row", isChecked)

      const selectedCount = $("input.table-checkbox-queue:checked").length
      const totalCount = $("input.table-checkbox-queue").length
      $("#check-all").prop("checked", selectedCount > 0 && selectedCount === totalCount)
    })

    $(this.checkAllTarget).on("change.notifierQueue", function () {
      const isChecked = $(this).prop("checked")
      $(".table-checkbox-queue")
        .prop("checked", isChecked)
        .closest("tr")
        .toggleClass("selected-row", isChecked)
    })
  }
}
